import { render, staticRenderFns } from "./PendingPayouts.vue?vue&type=template&id=6f00a946&scoped=true&"
import script from "./PendingPayouts.vue?vue&type=script&lang=js&"
export * from "./PendingPayouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f00a946",
  null
  
)

export default component.exports